/**
 * @class RefillHistoryRecord
 */
export default class RefillHistoryRecord {
    /**
     * @param {Number} id
     * @param {String} date
     * @param {Number} index
     * @param {Number} volumeMl
     * @param {Number} amount
     * @param {String} ufi
     * @param {String} batch
     * @param {Number} type
     */
    constructor(id, date, index, volumeMl, amount, ufi, batch, type) {
        this._id = id;
        this._date = date;
        this._index = index;
        this._volumeMl = volumeMl;
        this._amount = amount;
        this._ufi = ufi;
        this._batch = batch;
        this._type = type;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - RefillHistoryRecord");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get date() {
        return this._date;
    }

    /**
     * @param {String} date
     */
    set name(date) {
        this._date = date;
    }

    /**
     * @return {Number}
     */
    get index() {
        return this._index;
    }

    /**
     * @param {Number} index
     */
    set index(index) {
        this._index = index;
    }

    /**
     * @return {Number}
     */
    get volumeMl() {
        return this._volumeMl;
    }

    /**
     * @param {Number} volumeMl
     */
    set volumeMl(volumeMl) {
        this._volumeMl = volumeMl;
    }

    /**
     * @return {Number}
     */
    get amount() {
        return this._amount;
    }

    /**
     * @param {Number} amount
     */
    set amount(amount) {
        this._amount = amount;
    }

    /**
     * @return {String}
     */
    get ufi() {
        return this._ufi;
    }

    /**
     * @param {String} ufi
     */
    set ufi(ufi) {
        this._ufi = ufi;
    }

    /**
     * @return {String}
     */
    get batch() {
        return this._batch;
    }

    /**
     * @param {String} batch
     */
    set batch(batch) {
        this._batch = batch;
    }

    /**
     * @return {Number}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {Number} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {String}
     */
    toString() {
        return "RefillHistoryRecord (" + this._id + this._date + this._index + this._volumeMl + ")";
    }
}
